import type { QueueType } from "./QueueType.js";
import { readJsonQueueType } from "./QueueType.js";


export interface QueueState {
    queueType: QueueType;
}


export function readJsonQueueState(json: Record<string, any>): QueueState {
    const queueType = readJsonQueueType(json);
    return { queueType };
}
